<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.editService.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.editService.requiredHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('manageEvent.editService.serviceName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.editService.serviceNamePlaceholder' | translate"
          [(value)]="service.event_service_name"
          [invalid]="isServiceNameInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'manageEvent.editService.availableSlots' | translate"
          [type]="'number'"
          [placeholder]="'manageEvent.editService.availableSlotsPlaceholder' | translate"
          [(value)]="service.max_num_registrations"
        />
      </div>
    </div>
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'manageEvent.editService.serviceDescription' | translate"
          [type]="'text'"
          [placeholder]="'manageEvent.editService.serviceDescriptionPlaceholder' | translate"
          [(value)]="service.event_service_description"
        />
      </div>
    </div>
    <!-- Pricing Section -->
    <div class="row g-4 spacing-15">
      <div class="col-12">
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="isFreeService"
            [checked]="isFree"
            (change)="toggleFree($any($event.target).checked)"
          >
          <label class="form-check-label" for="isFreeService">
            {{ 'manageEvent.addService.freeService' | translate }}
          </label>
          <div class="form-text text-muted">{{ 'manageEvent.addService.freeServiceHint' | translate }}</div>
        </div>
      </div>
    </div>

    @if (!isFree) {
      <div class="row g-4">
        <div class="col-lg-4 col-12">
          <app-input-component
            [label]="'manageEvent.editService.price' | translate"
            [type]="'number'"
            [placeholder]="'manageEvent.editService.pricePlaceholder' | translate"
            [(value)]="service.price"
          />
          @if (service.price && service.price > 0) {
            <div class="text-muted small mt-1">
              {{ 'common.netAmountHint' | translate:{ amount: calculateNetAmount(service.price || 0), currency: service.price_currency || 'NOK' } }}
            </div>
          }
        </div>
        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.editService.priceCurrency' | translate"
            [options]="currencyOptions"
            [displayKey]="'name'"
            [valueKey]="'code'"
            [value]="service.price_currency"
            [disabled]="true"
          />
        </div>
        <div class="col-lg-4 col-12">
          <app-selectorini
            [label]="'manageEvent.editService.vat' | translate"
            [options]="vatRateOptions"
            [displayKey]="'label'"
            [valueKey]="'value'"
            [value]="service.vat_rate || 0"
            (valueChange)="service.vat_rate = $event"
          />
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <app-button
      [variant]="'primary'"
      [size]="'md'"
      [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
      [label]="saving ? ('common.saving' | translate) : ('common.saveChanges' | translate)"
      [disabled]="saving"
      (clicked)="saveChanges()"
    />
  </div>
</div>
